module.exports = __webpack_public_path__ + "static/media/5.809b9cd2.webp";